import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Container, CircularProgress } from "@material-ui/core";
import Upcoming from "./Upcoming";
import { UpcomingEventsContext } from "contexts/UpcomingEventsContext";

export default () => {
  const { events, loading, markSeen } = React.useContext(
    UpcomingEventsContext
  );
  const history = useHistory();
  const location = useLocation();

  // Visiting this page (with events actually loaded) is what "seen"
  // means - also re-runs on every background poll while the user is
  // sitting here, so a newly-added event doesn't leave a stale badge.
  React.useEffect(() => {
    if (!loading) {
      markSeen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events, loading]);

  // Event detail is its own full page (/events/:id), not a modal -
  // pass along where we came from so it knows where "back" goes.
  const onSelectEvent = (event) => {
    history.push(`/events/${event.id}`, { from: location });
  };

  return (
    <Container>
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <Upcoming events={events} onSelectEvent={onSelectEvent} />
      )}
    </Container>
  );
};
